import React from "react";
import S from "./HsEventForm.styled";
import { Script } from "gatsby";
import { IWPTitleParts } from "@/src/types";
import TitleParts from "@/components/global-components/TitleParts";

export interface IHsEventFormProps {
  titleParts: IWPTitleParts;
  title: string;
  description: string;
  formId: string;
  blockId: string;
}

const HsEventForm: React.FC<IHsEventFormProps> = ({
  titleParts,
  title,
  description,
  formId,
  blockId,
}) => {
  const [pageLoaded, setPageLoaded] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setPageLoaded(true);
    }
  }, []);
  return (
    <S.Section>
      <S.Inner id={blockId}>
        <S.Title>
          {titleParts ? (
            <TitleParts titleParts={titleParts} backgroundColor="white" />
          ) : (
            title && title
          )}
        </S.Title>
        {description && <S.Description>{description}</S.Description>}
        {pageLoaded && (
          <>
            <Script src="https://js.hsforms.net/forms/embed/4245941.js" defer />
            <div
              className="hs-form-frame"
              data-region="na1"
              data-form-id={formId}
              data-portal-id="4245941"
            />
          </>
        )}
      </S.Inner>
    </S.Section>
  );
};

export default HsEventForm;
